enum ReturnSourceType {
  EXTERNAL_ORDER = "external-order",
  ONLINE_ORDER = "online-order",
  ORDER_CONTENT = "order-content",
}

export default ReturnSourceType;
